document.addEventListener("init-create-own-upload", function (e) {
  $('.custom-radio[name="print-size"]').change(function () {
    $(".error-msg").remove();
    $(".main-product-image").hide();
    $(".pattern-container-main").show();
    var curimage = $('.custom-radio[name="print-size"]:checked').attr(
      "data-img"
    );
    $(".pattern-layer").attr("src", curimage);
    $(".pattern-layer").attr("href", curimage);
  });

  $('.custom-radio[name="core_colors"]').change(function () {
    $(".error-msg").remove();
    var curimage = $('.custom-radio[name="core_colors"]:checked').attr(
      "data-img"
    );
    var corecolor = $('.custom-radio[name="core_colors"]:checked').attr(
      "value"
    );
    $(".background-layer").css("background", "url(" + curimage + ")");
    $(".background-layer").attr("data-popupimage", curimage);
    $(".cur-core-color").html(corecolor);
    if (corecolor == "Upgrade (+5.00)") {
      //$(".thickness-options-wrapper").show();
      $(".upgrade-option-wrapper").show();
    } else {
      //$(".thickness-options-wrapper").hide();
      $(".upgrade-option-wrapper").hide();
      $(".upgrade-option-inner").hide();
      $(".upgrade-option-wrapper").find(".custom-option-select").val("");
      $(".upgrade-option-inner").find(".custom-option-select").val("");
    }
    if ($('input[name="whitelayer"]:checked').val() == "Full White") {
      $(".background-layer").css("display", "none");
      $(".background-layer").attr("data-popupimage", "");
    } else {
      $(".background-layer").css("display", "block");
      $(".background-layer").attr("data-popupimage", curimage);
    }
    const startEvent = new Event("updatePriceCustom");
    document.dispatchEvent(startEvent);
  });

  $('.custom-radio[name="whitelayer"]').change(function () {
    var curimage = $('.custom-radio[name="core_colors"]:checked').attr("data-img");
    if ($('input[name="whitelayer"]:checked').val() == "Full White") {
      $(".background-layer").css("display", "none");
      $(".background-layer").attr('data-popupimage','');
    } else {
      $(".background-layer").css("display", "block");
      $(".background-layer").attr('data-popupimage', curimage);
    }
    $(".error-msg").remove();
  });

  $('.custom-radio[name="print_sides"]').change(function () {
    const startEvent = new Event("updatePriceCustom");
    document.dispatchEvent(startEvent);

    $(".error-msg").remove();
  });

  $('.custom-radio[name="thickness"]').change(function () {
    $('.custom-option[data-opt="MDF Wood"]').hide();
    $('.custom-option[data-opt="Upgrade (+5.00)"]').hide();
    $('label[for="custom-core-color-1"]').click();
    console.log($(this).val());
    if ($(this).val() == "1/8") {
      $('.custom-option[data-opt="MDF Wood"]').show();
      $('.custom-option[data-opt="Upgrade (+5.00)"]').show();
    }
    $(".error-msg").remove();
  });

  $(".upgrade-option-wrapper .custom-option-select").change(function () {
    $(".error-msg").remove();
    const selectedValue = $(this).val();

    if (selectedValue === "") {
      $(".upgrade-option-inner").hide();
      $(".upgrade-option-inner .custom-option-select").val("");
      $(".background-layer").css("background", "");
      $(".background-layer").attr('data-popupimage',"");
    } else {
      checkUpgradeOptionAvailability(selectedValue);
    }
  });

  $(".upgrade-option-inner")
    .find(".custom-option-select")
    .change(function () {
      $(".error-msg").remove();
      if ($(this).val() == "") {
        $(".background-layer").css("background", "");
        $(".background-layer").attr('data-popupimage',"");
      } else {
        var backimage = $(this).find("option:selected").attr("data-img");
        $(".background-layer").css("background", "url(" + backimage + ")");
        $(".background-layer").attr('data-popupimage', backimage);
      }
      if ($('input[name="whitelayer"]:checked').val() == "Full White") {
        $(".background-layer").css("display", "none");
        $(".background-layer").attr('data-popupimage','');
      } else {
        $(".background-layer").css("display", "block");
        $(".background-layer").attr('data-popupimage', backimage);
      }
    });

  $("#legalConfirm").change(function () {
    $(".legal-error-msg").hide();
  });
  $(document).on("click", ".add-to-cart", function (e) {
    
    e.preventDefault();
    if (!$("#legalConfirm").is(":checked")) {
      $(".legal-error-msg").show();
      $("html, body").animate(
        { scrollTop: $("#legalConfirm").offset().top - 120 },
        500
      );

      return;
    } else {
      $(".legal-error-msg").hide();
    }

    const $btn = $(this);
    const $form = $btn.closest("form");
    if ($btn.data("submitting")) return;
    $btn.data("submitting", true);
    $btn.addClass("btn--loading");

    let proceed = true;
    let firstErrorElement = null;

    function highlightRadioGroup(name) {
      const $group = $('input[name="' + name + '"]');
      const isValid = $group.is(":checked");
      $group.each(function () {
        $(this).parents(".custom-option-wrapper").find(".error-msg").remove();
        const $label = $(this)
          .parents(".custom-option-wrapper")
          .find(".variant__label");
        if (!isValid) {
          $label.append(
            '<span class="error-msg">Select an option first</span>'
          );
          if (!firstErrorElement) firstErrorElement = $label;
        } else {
          $label.removeClass("radio-error");
        }
      });
      return isValid;
    }

    function highlightSelect($select) {
      if (!$select.val()) {
        const $label = $select
          .parents(".custom-option-wrapper")
          .find(".variant__label");
        $label.append('<span class="error-msg">Select an option first</span>');
        if (!firstErrorElement) firstErrorElement = $select;
        return false;
      } else {
        $select.removeClass("select-error");
        return true;
      }
    }

    const printSizeValid = highlightRadioGroup("print-size");
    const coreColorValid = highlightRadioGroup("core_colors");
    const whiteLayerValid = highlightRadioGroup("whitelayer");
    const thicknessValid = highlightRadioGroup("thickness");
    const printSidesValid = highlightRadioGroup("print_sides");

    if (
      !printSizeValid ||
      !coreColorValid ||
      !thicknessValid ||
      !whiteLayerValid ||
      !printSidesValid
    ) {
      proceed = false;
    }

    const corecolor = $('input[name="core_colors"]:checked').val();
    if (corecolor === "Upgrade (+5.00)") {
      const $upgradeSelect = $(".upgrade-option-wrapper").find(
        ".custom-option-select"
      );
      const upgradeValid = highlightSelect($upgradeSelect);
      if (!upgradeValid) proceed = false;
      const $innerSelect = $(
        '.upgrade-option-inner[data-upgradename="' + $upgradeSelect.val() + '"]'
      ).find(".custom-option-select");
      if ($innerSelect.length) {
        const innerValid = highlightSelect($innerSelect);
        if (!innerValid) proceed = false;
      }
    }

    if (!proceed && firstErrorElement) {
      $("html, body").animate(
        {
          scrollTop: firstErrorElement.offset().top - 100,
        },
        500
      );
      $btn.removeData("submitting").removeClass("btn--loading");
      return;
    }

    let items = [];
    let uid = typeof uniqueId === "function" ? uniqueId() : Date.now();
    const variantId = $form.find('[name="id"]').val();
    if (corecolor === "Upgrade (+5.00)") {
      items.push({
        id: 40596906639424,
        quantity: 1,
        properties: {
          _upgradeFor: variantId,
          _uid: uid,
        },
      });
    }
    if (
      $('input[name="print_sides"]:checked').val() === "Double Sided (+5.00)"
    ) {
      items.push({
        id: 40596938588224,
        quantity: 1,
        properties: {
          _upgradeFor: variantId,
          _uid: uid,
        },
      });
    }

    function addHiddenInput(name, value) {
      $form.append(
        $("<input>", {
          type: "hidden",
          name: "properties[" + name + "]",
          value: value,
          class: "js-dyn-prop",
        })
      );
    }

    function submitMainForm() {
      $form.find(".js-dyn-prop").remove();
      addHiddenInput("Print Size", $('input[name="print-size"]:checked').val());
      addHiddenInput("Core Color", corecolor);
      addHiddenInput("_customId", uid);
      if (corecolor === "Upgrade (+5.00)") {
        addHiddenInput("Thickness", $('input[name="thickness"]:checked').val());
        const $upgradeSelect = $(".upgrade-option-wrapper").find(
          ".custom-option-select"
        );
        addHiddenInput("Color Categories", $upgradeSelect.val());
        const $innerSelect = $(
          '.upgrade-option-inner[data-upgradename="' +
            $upgradeSelect.val() +
            '"]'
        ).find(".custom-option-select");
        if ($innerSelect.length) {
          addHiddenInput(
            $upgradeSelect.val() + " Acrylic Color",
            $innerSelect.val()
          );
          addHiddenInput(
            "_upgradeProduct",
            $innerSelect.find("option:selected").attr("data-productid")
          );
        }
      }
      addHiddenInput(
        "White Layer",
        $('input[name="whitelayer"]:checked').val()
      );
      addHiddenInput("_customId", uid);
      addHiddenInput(
        "Print Sides",
        $('input[name="print_sides"]:checked').val()
      );
      //  $form[0].submit();
      var data = new FormData($form[0]);

      fetch(theme.routes.cartAdd, {
        method: "POST",
        body: data,
        credentials: "same-origin",
        headers: {
          "X-Requested-With": "XMLHttpRequest",
        },
      })
        .then((response) => response.json())
        .then(function (data) {
          if (data.status === 422) {
            console.error("Error adding to cart:", JSON.stringify(data));
            $(".add-to-cart").removeClass("btn--loading");
            $(".add-to-cart").after(
              '<span class="error-msg">Error adding to cart</span>'
            );
            $btn.removeData("submitting");
          } else {
            console.log("Product added:", data);
            $(".add-to-cart").removeClass("btn--loading");
            const startEvent = new Event("ajaxProduct:added");
            document.dispatchEvent(startEvent);
            $btn.removeData("submitting");
            $form[0].reset();
            $form.find('.js-dyn-prop').remove();
            $('#uploadFileInput').val('');
            $(".error-msg, .legal-error-msg").hide();
            $('.custom-radio[name="thickness"]').prop('checked',false);
            $('.custom-radio[name="core_colors"]').prop('checked',false);
            $('.custom-radio[name="whitelayer"]').prop('checked',false);
            $('.custom-radio[name="print_sides"]').prop('checked',false);
            $(".custom-option-select").val("");
            $('.upgrade-option-wrapper').hide();
            $('.upgrade-option-inner').hide();
          }
        });
    }

    e.preventDefault();

    if (items.length > 0) {
      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({ items: items }),
      })
        .then((res) => {
          if (!res.ok) throw new Error();
          return res.json();
        })
        .then(() => {
          submitMainForm();
        })
        .catch(() => {
          $btn.removeData("submitting").removeClass("btn--loading");
        });
    } else {
      submitMainForm();
    }
  });

  function uniqueId() {
    return (
      "id-" +
      Date.now().toString(36) +
      "-" +
      Math.random().toString(36).substr(2, 5)
    );
  }

  function checkUpgradeOptionAvailability(selectedValue) {
    const $matchedInner = $(
      '.upgrade-option-inner[data-upgradename="' + selectedValue + '"]'
    );

    if ($matchedInner.length > 0) {
      $(".upgrade-option-inner").hide();
      $matchedInner.show();
      $(".background-layer").css("background", "");
      $(".background-layer").attr('data-popupimage',"");

      const $select = $matchedInner.find(".custom-option-select");

      const visibleOptionsCount = $select.find("option").filter(function () {
        return $(this).css("display") !== "none" && $(this).val() !== "";
      }).length;

      if (visibleOptionsCount === 0) {
        $matchedInner.append(
          '<div class="error-msg" style="color:red;margin-top:10px;">No available options for this upgrade.</div>'
        );
      }
    } else {
      const backimage = $(".custom-option-select option:selected").attr(
        "data-img"
      );
      $(".background-layer").css("background", "url(" + backimage + ")");
      $(".background-layer").attr('data-popupimage', backimage);
    }

    // Handle white layer toggle
    if ($('input[name="whitelayer"]:checked').val() === "Full White") {
      $(".background-layer").hide();
      $(".background-layer").attr('data-popupimage',"");
    } else {
      $(".background-layer").show();
      $(".background-layer").attr('data-popupimage', backimage);
    }
  }

  function normalizeSize(value) {
    return (
      value
        ?.replace(/["“”]/g, "") // remove quotes
        .replace(/\s+/g, "") // remove spaces
        .replace(/x\d+-\d+/gi, function (match) {
          const parts = match.match(/\d+/g);
          return "x" + (parts ? parts[1] : match); // keep upper range
        }) || ""
    );
  }

  function updateOptionVisibility(selectedSizeRaw) {
    const selectedSize = normalizeSize(selectedSizeRaw);

    $("select option").each(function () {
      const $option = $(this);
      const rawData = $option.attr("data-variants");

      if (!rawData) {
        $option.show(); // show by default if no variant data
        return;
      }

      let raw = $option.attr("data-variants");
      let variants;

      try {
        variants = JSON.parse(raw);
      } catch (e) {
        console.error("Invalid JSON in option:", $option, e);
      }

      const hasMatchingVariant = variants.some(function (variant) {
        const titleNormalized = normalizeSize(variant.title);
        return titleNormalized.includes(selectedSize);
      });

      $option.toggle(hasMatchingVariant);
    });
  }

  // On change of size radio input
  $('input[name="Size"]').on("change", function () {
    updateOptionVisibility(this.value);
    const selectedUpgrade = $(
      ".upgrade-option-wrapper .custom-option-select"
    ).val();
    if (selectedUpgrade) {
      $(".error-msg").remove();
      checkUpgradeOptionAvailability(selectedUpgrade);
    }
  });

  // Initial trigger on page load
  const initialSize = $('input[name="Size"]:checked').val();
  if (initialSize) updateOptionVisibility(initialSize);

  $("#uploadFileInput").on("change", function () {
    var file = this.files[0];
    if (!file) return;
    var allowed = ["pdf", "ai", "eps"];
    var ext = file.name.split(".").pop().toLowerCase();
    if (allowed.indexOf(ext) === -1) {
      alert("Only PDF, AI, or EPS files are allowed.");
      $(this).val("");
    }
  });
});

$('.pattern-layer').unbind().click(function(){
  var curimage = $('.background-layer').attr("data-popupimage");
  setTimeout(function() {
    $(".fancybox-content").css("background", "url(" + curimage + ")");
  }, 100);  
});

$('.pattern-zoom-in').unbind().click(function(){
  $('.pattern-layer').trigger('click');
});

